import type {Component} from 'typings/portaro.fe.types';
import type {ModalWindowBindings, ModalWindowResolveValues} from '../conversation';
import type {IOnInit} from 'angular';
import type LoanDataService from '../../data-services/loan.data-service';
import type {Loan} from 'typings/portaro.be.types';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {createPayloadActionResponse} from '../modal-utils';

export class LoanSelectionModalComponentController implements ModalWindowBindings<LoanSelectionModalModel>, IOnInit {
    public resolve: ModalWindowResolveValues<LoanSelectionModalModel>;
    public loans: Loan[];

    /*@ngInject*/
    constructor(private loanDataService: LoanDataService) {
    }

    @ngAsync()
    public async $onInit() {
        const filter = this.resolve.model?.loansFilter ?? angular.identity;

        this.loans = filter(await this.loanDataService.getByExemplarId(this.resolve.model.exemplarId));
    }

    public selectLoan(selectedLoan: Loan) {
        this.resolve.modalWindowActions.submitPromise(Promise.resolve(createPayloadActionResponse(selectedLoan)));
    }

    public close() {
        this.resolve.modalWindowActions.cancel();
    }
}

/**
 * @ngdoc component
 * @name loanSelectionModal
 * @module portaro.conversation
 *
 * @description
 *
 */
export default class LoanSelectionModalComponent implements Component<ModalWindowBindings<LoanSelectionModalModel>> {
    public static componentName = 'loanSelectionModal';

    public templateUrl = require('./loan-selection-modal.tpl.ftl');

    public bindings = {
        resolve: '<'
    } as const;

    public controller = LoanSelectionModalComponentController;
}

export interface LoanSelectionModalModel {
    exemplarId: number;

    loansFilter(loans: Loan[]): Loan[];
}